module.exports = ".collapseShow {\n    display: none !important;\n}\n\n.collapseHidden {\n    display: none !important;\n}\n\n/* .hide-me[aria-expanded=\"true\"] {display: none;} */\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/products/products.component.css
// module id = ./src/app/views/products/products.component.css
// module chunks = main